// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3-CdW","file":"styles_file__2EC44"};